import React, { createContext, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { getFaqs, getFaq, createFaq, updateFaq, deleteFaq } from '../services/api';

export const FaqContext = createContext();

export const FaqProvider = ({ children }) => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchFaqs = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getFaqs();
      setFaqs(response.data);
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'خطا در دریافت سوالات';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchFaq = useCallback(async (id) => {
    setLoading(true);
    setError(null);
    try {
      const response = await getFaq(id);
      return response.data;
    } catch (err) {
      const errorMessage =
        err.response?.status === 404 ? 'سوال مورد نظر یافت نشد' : err.response?.data?.message || 'خطا در دریافت سوال';
      setError(errorMessage);
      toast.error(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const addFaq = useCallback(async (faqDto) => {
    setLoading(true);
    setError(null);
    try {
      const response = await createFaq(faqDto);
      setFaqs((prev) => [...prev, response.data]);
      toast.success('سوال با موفقیت اضافه شد');
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'خطا در افزودن سوال';
      setError(errorMessage);
      toast.error(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const editFaq = useCallback(async (id, faqDto) => {
    setLoading(true);
    setError(null);
    try {
      const response = await updateFaq(id, faqDto);
      setFaqs((prev) => prev.map((faq) => (faq.id === id ? response.data : faq)));
      toast.success('سوال با موفقیت به‌روزرسانی شد');
      return response.data;
    } catch (err) {
      const errorMessage =
        err.response?.status === 404 ? 'سوال مورد نظر یافت نشد' : err.response?.data?.message || 'خطا در به‌روزرسانی سوال';
      setError(errorMessage);
      toast.error(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const removeFaq = useCallback(async (id) => {
    setLoading(true);
    setError(null);
    try {
      await deleteFaq(id);
      setFaqs((prev) => prev.filter((faq) => faq.id !== id));
      toast.success('سوال با موفقیت حذف شد');
    } catch (err) {
      const errorMessage =
        err.response?.status === 404 ? 'سوال مورد نظر یافت نشد' : err.response?.data?.message || 'خطا در حذف سوال';
      setError(errorMessage);
      toast.error(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <FaqContext.Provider
      value={{
        faqs,
        loading,
        error,
        fetchFaqs,
        fetchFaq,
        addFaq,
        editFaq,
        removeFaq,
      }}
    >
      {children}
    </FaqContext.Provider>
  );
};